<template>
  <div
    class="rounded-full border flex items-center space-x-1.5 px-1.5 py-0.5 font-semibold text-label whitespace-nowrap w-max bg-white select-none"
    data-cy="funder-placement-count-tag"
  >
    <div class="transform translate-y-0-25">
      <icon-base
        :icon="tagConfig.icon"
        :class="tagConfig.className"
        :fill="tagConfig.fill"
        width="16"
        height="16"
        data-cy="funder-placement-count-tag-icon"
      />
    </div>

    <div class="space-x-1 pr-1">
      <span data-cy="funder-placement-count-tag-count">{{ count }}</span>
      <span class="uppercase">{{ $t(tagConfig.labelKey) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import IconClock from "@/components/icons/IconClock.vue";
import IconExclamationMarkRound from "@/components/icons/IconExclamationMarkRound.vue";
import IconSuccessRoundBig from "@/components/icons/IconSuccessRoundBig.vue";
import IconXCircle from "@/components/icons/IconXCircle.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { Component } from "vue";

export type PlacementCountType = "approved" | "pending" | "declined" | "error";

interface TagConfig {
  icon: Component;
  className: string;
  labelKey: string;
  fill?: string;
}

const props = defineProps<{
  type: PlacementCountType;
  count: number;
}>();

const tagTypeConfigMap: Record<PlacementCountType, TagConfig> = {
  approved: {
    icon: IconSuccessRoundBig,
    className: "text-green-500",
    labelKey: "DEALS.PLACEMENT.STATUS.APPROVED",
  },
  pending: {
    icon: IconClock,
    className: "text-orange-500",
    labelKey: "DEALS.PLACEMENT.STATUS.PENDING",
  },
  declined: {
    icon: IconXCircle,
    className: "text-red-600",
    labelKey: "DEALS.PLACEMENT.STATUS.DECLINED",
  },
  error: {
    icon: IconExclamationMarkRound,
    className: "",
    labelKey: "DEALS.PLACEMENT.STATUS.ERROR",
    fill: "#DC2626",
  },
};

const tagConfig = computed(() => tagTypeConfigMap[props.type]);
</script>
